module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="container-fluid">\n  <div class="row">\n    <div class="col-md-12">\n      <h1>Unauthorized</h1>\n      <p><strong>Error code 401</strong></p>\n      <p>It is not possible for you to access this page. An admin user account is required.</p>\n    </div>\n  </div>\n</div>\n';

}
return __p
}